import { GroupBasic } from './group'

export interface Assignment {
    id: number,
    name: string,
    table: string,
    groups?: GroupBasic[]
  }

export class AssignmentPerType {
  public AdDmAffectationEleve: Assignment[]
  public AdDmAffectationEnseignant: Assignment[]
  public AdDmAffectationRemplacant: Assignment[]
  public AdDmAffectationExtra: Assignment[]
  public AdDmAffectationPartenaire: Assignment[]
  public AdDmAffectationPersonnel: Assignment[]
  public AdDmFonctionEtablissement: Assignment[]
  public RefeduDmAnneeVoie: Assignment[]

  constructor() {
    this.AdDmAffectationEleve = []
    this.AdDmAffectationEnseignant = []
    this.AdDmAffectationRemplacant = []
    this.AdDmAffectationExtra = []
    this.AdDmAffectationPartenaire = []
    this.AdDmAffectationPersonnel = []
    this.AdDmFonctionEtablissement = []
    this.RefeduDmAnneeVoie = []
  }
}
